'use client';

import { Box } from '@skin-seoul/design-system';
import BlogPostCard from './BlogPostCard';
import { useState, useEffect } from 'react';
import { useBlogService } from '@skin-seoul/service';
import { Carousel, type CarouselApi } from '@/components/ui/Carousel';
import { CarouselNavigation } from '@/components/ui/Carousel';
const BlogSwiper = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    useGetBlogPostsSummary
  } = useBlogService();
  const {
    data: blogPosts
  } = useGetBlogPostsSummary({
    limit: 6
  });
  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSelect = () => {
      setActiveIndex(api.selectedScrollSnap());
    };
    api.on('select', handleSelect);
    api.on('reInit', handleSelect);
    handleSelect();
    return () => {
      api.off('select', handleSelect);
    };
  }, [api]);
  return <Box width="100%" display={{
    base: 'none',
    tablet: 'flex',
    desktop: 'flex'
  }} flexDirection="column" gap={12} data-sentry-element="Box" data-sentry-component="BlogSwiper" data-sentry-source-file="BlogSwiper.tsx">
      <Box position="relative" width="100%" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="BlogSwiper.tsx">
        <Carousel setApi={setApi} opts={{
        loop: true,
        align: 'start',
        skipSnaps: false
      }} w="100%" data-sentry-element="Carousel" data-sentry-source-file="BlogSwiper.tsx">
          <Carousel.Content data-sentry-element="Carousel.Content" data-sentry-source-file="BlogSwiper.tsx">
            {blogPosts.map(post => <Carousel.Item key={post.id} flexBasis={{
            desktop: '25%',
            tablet: '50%',
            base: '100%'
          }} px="12px">
                <BlogPostCard title={post.title} image={post.thumbnailUrl1024x512} date={post.publishedAt} readTime={`${post.readingTimeMinutes} min read`} link={post.url} />
              </Carousel.Item>)}
          </Carousel.Content>
        </Carousel>
      </Box>
      <CarouselNavigation api={api} activeIndex={activeIndex} totalItems={blogPosts.length} data-sentry-element="CarouselNavigation" data-sentry-source-file="BlogSwiper.tsx" />
    </Box>;
};
export default BlogSwiper;